import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" id=\"icon-check\">\n  <title>check</title>\n  <g>\n    <path d=\"M25,43.75A18.75,18.75,0,1,0,6.25,25,18.75,18.75,0,0,0,25,43.75ZM25,50A25,25,0,1,1,50,25,25,25,0,0,1,25,50Z\" />\n    <path d=\"M22.35,28.38l10-15.88,5.12,3.71L24.05,37.5,12.5,29.38l3.39-5.54Z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/check.svg
// module id = 110
// module chunks = 0 1 2